import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import { ActivatedRoute, Params, ParamMap } from '@angular/router';
import { CommunicationsHttpService } from '../../../../services/communications/communications.http.service';
import { CommunicationsHttpUtil } from '../communications.util';
import { StorageUtil } from '../../../../utils/storage.util';
import { CommunicationsStateService } from '../communications.state.service';
import { AuthUtil } from '../../../../utils/auth.utils';
import { Observable, Subject } from 'rxjs';

@Component({
  moduleId: module.id,
  templateUrl: 'open.communications.component.html',
  selector: 'bft-open-communications',
  providers: []
})

export class OpenCommunicationsComponent implements OnInit, OnDestroy {

  @Input() newQuest;

  searchTextSubscription: Subject<string> = new Subject();
  private _searchText: string;
  @Input() set searchText(value) {
    this.searchTextSubscription.next(value);
  }


  @Output() resetOpenQuest = new EventEmitter<any>();


  model: any = {};
  errorMessage: string;

  activeModelNumber = '';

  reloadDataSubscription: any;

  constructor(
    private communicationsHttpService: CommunicationsHttpService,
    private communicationsStateService: CommunicationsStateService,
    private authUtil: AuthUtil
    ) {
      this.followFilteredQuest();
    }

  ngOnInit() {
    if (this.newQuest.number) {
      this.setNewQuest(this.newQuest);
      this.newQuest = {};
      this.resetOpenQuest.next();
    } else {
      this.getOpenQuest();
    }

    this.communicationsStateService.handleNewQuest().subscribe(data => {
      // TODO: revert after get chatId after create chat;
      // this.setNewQuest(data);
      this.getOpenQuest();
    });

    this.reloadDataSubscription = this.communicationsStateService.handleReloadData().subscribe(data => {
      this.getOpenQuest();
    });
  }

  openQuest(number, theme, chatType) {
    this.communicationsStateService.triggerSingleQuest({number: number, questType: 'open', theme: theme, chatType: chatType});
  }

  setActiveModel(item) {
    this.activeModelNumber = item.number;
  }

  getOpenQuest(searchText?: string) {
    let requestParams = this.getQuestParams(1, searchText);
    this.communicationsHttpService.getChats(requestParams).subscribe(
      success => {
        this.callbackSuccessGetGuest(success);
      },
      error => {
      },
      () => {
      });
  }

  getFilteredQuest(searchText): Observable<any> {
    const requestParams = this.getQuestParams(1, searchText);
    return this.communicationsHttpService.getChats(requestParams);
  }

  private followFilteredQuest(): void {
    this.searchTextSubscription
      .debounceTime(500)
      .switchMap(text => this.getFilteredQuest(text))
      .subscribe(success => {
        this.callbackSuccessGetGuest(success);
      });
  }

  private getQuestParams(active, searchText?): URLSearchParams {
    return CommunicationsHttpUtil.prepareParamsGetChats({
      securityToken: StorageUtil.getToken(),
      active: active,
      filter: searchText || ''
    });
  }

  private callbackSuccessGetGuest(success) {
    if (success) {
      let data = success.json();

      if (this.authUtil.isError(data)) {
        this.errorMessage = this.authUtil.errorMessage(data);
        this.authUtil.checkErrorResponse(data);
      } else {
        this.model = data.response && data.response.items || [];
        this.model = this.model.reverse();
      }
    }
  }

  setNewQuest(data) {
    this.activeModelNumber = data.number;
    this.getOpenQuest();
    this.openQuest(data.number, data.theme, data.chatType);
  }

  ngOnDestroy() {
    this.reloadDataSubscription.unsubscribe();
    this.searchTextSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/communications/open-communications/open.communications.component.ts